import { IStock, IStockRes } from '@/interfaces/stock';
import * as baseAdapter from './baseAdapter';
import { IBentoOrderRes } from '@/interfaces/order';

export const searchStocks = async (req: any) => {
  const ret = await baseAdapter.post<IStockRes>('/v1/stock/gets', req);
  return ret?.data;
};

export const updateStock = async (data: Partial<IStock>[]) => {
  const ret = await baseAdapter.put('/v1/stock/update', data);
  return ret?.data;
};

export const checkStocks = async (data: IBentoOrderRes[]) => {
  const ret = await baseAdapter.post<any>('/v1/stock/check-stock', data);
  return ret?.data;
};
